export default function Config(dataset, color) {
  const config = {
    color,
    dataset,
    legend: {
      top: '8%',
      right: 24,
      padding: [0, 10],
      orient: 'vertical',
      textStyle: { color: 'var(--m-link-normal)' },
      icon: 'circle',
      itemWidth: 9,
      itemHeight: 9,
    },
    grid: {
      containLabel: true,
      top: 30,
      right: 0,
      bottom: 30,
      left: 0,
    },
    series: [
      {
        type: 'pie',
        radius: ['47%', '74%'],
        center: ['50%', '50%'],
        startAngle: 130,
        avoidLabelOverlap: false,
        silent: true,
        encode: {
          itemName: 0,
          value: 1,
        },
        label: {
          formatter: '{b}: {d}%',
        },
        labelLine: {
          show: true,
          length: 10,
          length2: 20,
        }
      }
    ]
  }
  return config
}
